import axios from 'axios';

export const convertBase64File = async (base64, imageName, imageType = 'image/jpeg') => {
  const res = await fetch(base64);
  const buf = await res.arrayBuffer();

  const file = new File([buf], imageName, {
    type: imageType
  });
  return file;
};

export const fetchImage = async ({ endpoint, accessToken, customerToken }) => {
  const response = await axios.get(endpoint, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Customer-Token': customerToken
    },
    responseType: 'blob'
  });

  const blob = new Blob([response.data], { type: 'application/octet-stream' });

  return blob;
};

export const fetchAndSaveImage = async ({ setImage, endpoint, accessToken, customerToken }) => {
  const blob = await fetchImage({ endpoint, accessToken, customerToken });
  const reader = new FileReader();
  reader.readAsDataURL(blob);
  reader.onloadend = () => {
    setImage(reader.result);
  };
};

export const createFormData = async ({ frontImage, backImage, amount, checkId }) => {
  // init FormData instant
  const form = new FormData();

  if (amount) {
    form.append('amount', amount);
  }

  if (checkId) {
    form.append('id', checkId);
  }

  if (frontImage && backImage) {
    const [front, back] = await Promise.all([
      convertBase64File(frontImage, 'frontImage'),
      convertBase64File(backImage, 'backImage')
    ]);
    form.append('front', front);
    form.append('back', back);
    return form;
  }

  if (frontImage) {
    const front = await convertBase64File(frontImage, 'frontImage');
    form.append('front', front);
  }

  if (backImage) {
    const back = await convertBase64File(backImage, 'backImage');
    form.append('back', back);
  }

  return form;
};
